import { Card, CardContent, Typography } from '@mui/material';
import { cloneElement, FC } from 'react';
import { INavLink } from '../../models';

interface IPortalCard {
  link: INavLink;
}

export const PortalCard: FC<IPortalCard> = ({ link }) => {
  return (
    <Card>
      <CardContent
        sx={{
          padding: 1.5,
          textAlign: 'center'
        }}
      >
        {cloneElement(link.icon, { fontSize: 'large', color: 'primary' })}
        <Typography>{link.name}</Typography>
      </CardContent>
    </Card>
  );
};
